// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3VspO","cell":"ColumnAccessor_cell__34P8T","firstCellAccent":"ColumnAccessor_firstCellAccent__2dEa4"};